import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFieldShema} from '@usteknoloji/noosgrid';
import {GlobalObjectService} from '../../../../class/global-obj';
import * as _ from 'lodash';
import {BroadcastMessageService} from '@usteknoloji/noos-brodcast-messaging';

export interface IValueMap {
    field_name: string;
    field_title: string;
    field_alias: string;
    list_order: number;
    field_value: string[];
    is_link?: boolean
}

@Component({
    selector: 'noos-viewinfo',
    templateUrl: './viewinfo.component.html',
    styleUrls: ['./viewinfo.component.scss']
})
@NoosFormTypeService.register('viewInfo')
export class ViewinfoComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    formFieldStructure: IFieldShema[];
    formRecordData: any;

    items: IValueMap[] = [];

    constructor(private globalEventListenerService: BroadcastMessageService) {

    }

    ngOnInit() {
        this.formFieldStructure = _.orderBy(GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString()), ['list_order'], ['ASC']);
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());

        this.globalEventListenerService.eventView.subscribe(triggerN => {
            if (triggerN !== null) {
                console.log('Subview:', this.formId.toString());
                console.log(triggerN);
                this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());

                console.log(this.formRecordData);

                this.createItems();

            }
        });

    }

    convert_value(val) {
        if (val === null || val === undefined) {
            return '';
        }
        if (val.toString() === 'true') {
            return 'Evet';
        } else if (val.toString() === 'false') {
            return 'Hayır';
        }
        return val;
    }

    ngAfterViewInit(): void {
        this.createItems();


    }

    private createItems() {
        const valueList: IValueMap[] = [];
        this.prop.viewOptions.fieldRows.forEach(x => {

            const fieldData: string[] = [];
            x.fields.forEach(y => {
                let fieldAlias = '';
                let fieldName = '';

                const isField2 = this.formFieldStructure.filter(i => i.source_field_name === y.field_name);
                if (isField2.length > 0) {
                    fieldAlias = isField2[0].field_alias;
                    fieldName = isField2[0].field_name;
                    let fieldDataVal = '';
                    isField2.forEach(p => {
                        fieldDataVal += ' ' + this.convert_value(this.formRecordData[p.field_alias]);
                    });
                    fieldData.push(fieldDataVal.trim());

                } else {
                    const isField = this.formFieldStructure.filter(i => i.field_name === y.field_name);
                    if (isField.length > 0) {
                        fieldAlias = isField[0].field_alias;
                        fieldName = isField[0].field_name;
                        const fieldDataVal = this.formRecordData[fieldAlias];
                        fieldData.push(this.convert_value(fieldDataVal));
                    }
                }


            });

            const tempData = fieldData.join(' ');

            valueList.push({
                field_name: x.field_name,
                field_alias: '',
                field_title: x.label,
                list_order: x.list_order,
                field_value: fieldData,
                is_link: tempData.indexOf('http') === 0 || tempData.indexOf('https') === 0
            });

        });

        this.items = _.orderBy(valueList, ['list_order'], ['ASC']);
    }

    public isNumber(controlValue: string) {
        return typeof +controlValue === 'number' && !isNaN(+controlValue);
    }
}
